/**
 * @description
 * Objeto AuxiliarAOC
 */

import { RepresentantsAOC } from "./representantsaoc.model";

export class AuxiliarAOC {

    public identificador:string = "";
    public check:number = null;
    public dboid:string = "";
    public llamada: number;
    public carpeta: string ="";
    public representantsAOC: RepresentantsAOC[] = new Array<RepresentantsAOC>();
    
    constructor() {}
  
}